import { __require as _ } from "./_Symbol.js";
var t, n;
function d() {
  if (n) return t;
  n = 1;
  var a = _(), i = Object.prototype, o = i.hasOwnProperty, g = i.toString, e = a ? a.toStringTag : void 0;
  function c(r) {
    var s = o.call(r, e), u = r[e];
    try {
      r[e] = void 0;
      var f = !0;
    } catch {
    }
    var T = g.call(r);
    return f && (s ? r[e] = u : delete r[e]), T;
  }
  return t = c, t;
}
export {
  d as __require
};
